// import React from "react";

// const SvgWave = ({ data, width, height, style }) => {        
//     const barWidth = (width-2) / data.length; // 각 웨이브의 폭 - border 떄문에 양쪽 2 width를 제거 & 각 영역의 width를 구함.     

//     //전체 데이터의 최대 최소값 -75 +75로 간격 변경.
//     const combinedWave = data.flatMap(item => item.wave);
//     // const minY = Math.min(...combinedWave) - 75;
//     // const maxY = Math.max(...combinedWave) + 75;
//     const minY = Math.min(...combinedWave) - ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);
//     const maxY = Math.max(...combinedWave) + ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);

//     // wave 데이터 Y축을 SVG에 맞게 정규화
//     const normalizeY = (value, min, max) => {
//         if (value === 0 && min === 0 && max === 0) {            
//             return height / 2; 
//         }
//         return height - ((value - min) / (max - min)) * height;
//     };

//     return (
//         <svg            
//             width={width} 
//             height={height}            
//             className={style}
//         >            

//             {data.map((waveData, index) => {
//                 const backgroundX = index * barWidth;
//                 const backgroundWidth = barWidth;

//                 // 각 웨이브의 포인트 계산
//                 const points = waveData.wave
//                     .map((y, i) => {
//                         const x = (barWidth / (waveData.wave.length - 1)) * i + index * barWidth; //빈 값이 있을 경우 공백을 넣어서 표기하게끔 수정
//                         const normalizedY = normalizeY(y, minY, maxY);
//                         return `${x},${normalizedY}`;
//                     })
//                     .join(" ");

//                 return (
//                     // 선택 영역 업데이트
//                     <g key={index}>                        
//                         <rect
//                             x={backgroundX}
//                             y={0}
//                             width={backgroundWidth}
//                             height={height}
//                             fill="transparent"                              
//                         />
//                         <polyline
//                             points={points}
//                             fill="none"
//                             stroke="#fff"
//                             strokeWidth={1}
//                         />                       
//                     </g>
//                 );
//             })}
//         </svg>
//     );
// };

// export default SvgWave;

// 한줄로 표기 되는 로직인데, 빈 값인 경우 채워지지않는 문제가 있음.
// import React, {useState,useEffect} from "react";

// const SvgWave = ({ data, width, height, style }) => {
//     const [polylineData, setPolylineData] = useState();    

//     //전체 데이터의 최대 최소값 -75 +75로 간격 변경.
//     const combinedWave = data.flatMap(item => item.wave);
//     const minY = Math.min(...combinedWave) - ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);
//     const maxY = Math.max(...combinedWave) + ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);

//     // wave 데이터 Y축을 SVG에 맞게 정규화
//     const normalizeY = (value, min, max) => {
//         return height - ((value - min) / (max - min)) * height;
//     };

//     //데이터가 들어오면 한줄로 표기하는 로직.
//     useEffect(() => {
//         if(data){            
//             const flatData = data.flat().flatMap(item => item.wave);            
//             const points = flatData.map((y, i) => {                            
//                 const x = ((width-2) / flatData.length) * i;
//                 const normalizedY = y != null ? normalizeY(y, minY, maxY) : '';
//                 return y != null ? `${x},${normalizedY}` : `${x},`;
//             }).join(' ');
//             setPolylineData(points);
//         }
//     }, [data])

//     useEffect(() => {
//         console.log('Polyline Data:', polylineData);
//     }, [polylineData]);

//     return (
//         <svg            
//             width={width} 
//             height={height}            
//             className={style}
//         >            
//             {
//                 polylineData && (
//                     <polyline points={polylineData} fill="none" stroke="#fff" strokeWidth={1} /> 
//                 )                
//             }
//         </svg>
//     );
// };

// export default SvgWave;

// Rodeny - 2025.07.18 : 빈 값은 250개의 null 값으로 채워서 세팅 하는 로직을 추가 함.
import React, {useState,useEffect} from "react";

const SvgWave = ({ data, width, height, style }) => {
    const [polylineData, setPolylineData] = useState();    

    //전체 데이터의 최대 최소값 -75 +75로 간격 변경.
    //const combinedWave = data.flatMap(item => item.wave);
    const combinedWave = data.flatMap((item, dataIndex) => 
        item.wave.map((value, waveIndex) => {
            if (value == '-2147483648') {
                // 같은 웨이브 내의 이전 포인트가 있으면 사용
                if (waveIndex > 0) {
                    return item.wave[waveIndex - 1];
                }
                // 이전 데이터 아이템의 같은 위치 포인트가 있으면 사용
                if (dataIndex > 0 && data[dataIndex - 1]?.wave[waveIndex] != '-2147483648') {
                    return data[dataIndex - 1].wave[waveIndex];
                }
                // 둘 다 없으면 0 또는 기본값 사용
                return 0;
            }
            return value;
        })
    );
    // console.log('10초 combinedWave',combinedWave);
    const defaultMinY = -150
    const defaultMaxY = 300
    let minY = Math.min(...combinedWave) - ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);
    let maxY = Math.max(...combinedWave) + ((Math.max(...combinedWave) - Math.min(...combinedWave)) * 0.2);

    minY = Math.min(minY, defaultMinY)
    maxY = Math.max(maxY, defaultMaxY)

    // wave 데이터 Y축을 SVG에 맞게 정규화
    const normalizeY = (value, min, max) => {
        return height - ((value - min) / (max - min)) * height;
    };

    //데이터가 들어오면 한줄로 표기하는 로직.
    useEffect(() => {
        if(data){            
            // item.wave가 비어있으면 250개의 null 값으로 채움
            const processedData = data.flat().flatMap(item => {
                if (!item.wave || item.wave.length === 0) {
                    return new Array(250).fill(null);
                }
                return item.wave;
            });
            
            // 연속된 유효한 데이터만으로 polyline 생성
            let currentSegment = [];
            const segments = [];
            
            // processedData.forEach((y, i) => {
            //     const x = ((width-2) / processedData.length) * i;
                
            //     if (y != null) {
            //         const normalizedY = normalizeY(y, minY, maxY);
            //         currentSegment.push(`${x},${normalizedY}`);
            //     } else {
            //         // null 값을 만나면 현재 세그먼트를 저장하고 새로 시작
            //         if (currentSegment.length > 0) {
            //             segments.push(currentSegment.join(' '));
            //             currentSegment = [];
            //         }
            //     }
            // });
            processedData.forEach((y, i) => {
                const x = ((width-2) / processedData.length) * i;
                
                let adjustedY = y;
                
                // -2147483648인 경우 이전/다음 값으로 대체
                if (y == '-2147483648') {
                    // 이전 값이 있고 유효한 경우
                    if (i > 0 && processedData[i - 1] != '-2147483648' && processedData[i - 1] != null) {
                        adjustedY = processedData[i - 1];
                    }
                    // 다음 값이 있고 유효한 경우
                    else if (i < processedData.length - 1 && processedData[i + 1] != '-2147483648' && processedData[i + 1] != null) {
                        adjustedY = processedData[i + 1];
                    }
                    // 둘 다 없으면 null로 설정 (기존 로직 유지)
                    else {
                        adjustedY = null;
                    }
                }
                
                if (adjustedY != null) {
                    const normalizedY = normalizeY(adjustedY, minY, maxY);
                    currentSegment.push(`${x},${normalizedY}`);
                } else {
                    // null 값을 만나면 현재 세그먼트를 저장하고 새로 시작
                    if (currentSegment.length > 0) {
                        segments.push(currentSegment.join(' '));
                        currentSegment = [];
                    }
                }
            });
            
            // 마지막 세그먼트 추가
            if (currentSegment.length > 0) {
                segments.push(currentSegment.join(' '));
            }
            
            setPolylineData(segments);
        }
    }, [data])

    return (
        <svg            
            width={width} 
            height={height}            
            className={style}
        >            
            {
                polylineData && (
                    Array.isArray(polylineData) ? 
                        polylineData.map((segment, index) => (
                            <polyline key={index} points={segment} fill="none" stroke="#fff" strokeWidth={1} />
                        )) :
                        <polyline points={polylineData} fill="none" stroke="#fff" strokeWidth={1} />
                )                
            }
        </svg>
    );
};

export default SvgWave;
